class RequestInvoiceController {
    constructor($translate, $stateParams, $location, $state, myBookingService, locationsService, cacheService, sharedService) {
        'ngInject';
        this.name = 'requestInvoice';
        this.$translate = $translate;
        this.show_form = false;
        this.show_summary = false;
        this.customer = 'person';
        this.customer_is_active = false;
        this.company = 'company';
        this.company_is_active = false;
        this.client = {document: {type: 'tax-id'}};
        this.IS_MOBILE = sharedService.IS_MOBILE;
        this.countries = [];
        this.myBookingService = myBookingService;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.$state = $state;
        this.cacheService = cacheService;
        this.dataTransformed = {};
        this.createInvoiceResponse = {};
        this.nifRegex = /^([0-9]{8}[\w]{1}|[\w]{1}[0-9]{7}[\w]{1})$/i;

        locationsService.getCountries().then(response => {
            this.countries = response.reduce((items, item) => {
                items[item.id] = item;
                return items;
            }, []);

            function compareStrings(a, b) {
                a = a.toLowerCase();
                b = b.toLowerCase();
                return (a < b) ? -1 : (a > b) ? 1 : 0;
            }

            this.countries.sort(function(a, b) {
                return compareStrings(a.name, b.name);
            })
        });

        this.form_labels = {};
        this.form_labels[this.customer] = {
            'name' : 'name_invoice',
            'address': 'address_invoice'
        };
        this.form_labels[this.company] = {
            'name' : 'company_name',
            'address': 'registered_company_address'
        };
    }

    $onInit() {
        this.translations = this.$translate.instant([
            "invoice_details",
            "business_invoice",
            "personal_invoice",
            "required_invoice",
            "country_invoice",
            "tax_id_number",
            "submit_invoice",
            "invoice_almost_ready",
            "make_sure_details",
            "name_invoice",
            "address_invoice",
            "correct_details",
            "not_correct_details",
            "optional_invoice",
            "nif_number",
            "company_name",
            "registered_company_address"

        ]);
    }

    onCountryChange(id) {
        this.client.country = this.countries[id];
        if (this.client.country.isoCode === 'es') {
            this.client.document.type = 'nif';
        }
    }

    toggleForm(clientType) {

        this.show_form = true;
        this.client.type = clientType;
        if (clientType === this.company) {
            this.customer_is_active = false;
            this.company_is_active = true;
        }
        if (clientType === this.customer) {
            this.customer_is_active = true;
            this.company_is_active = false;
        }
    }

    hideSummary() {
        this.show_summary = false;
    }

    submit(form) {
        form.$submitted = true;
        if (form.$valid) {
            this.show_summary = true;
        }
    }

    dataTransform(){
        this.dataTransformed = {
            content:{
                type: this.client.type,
                name: this.client.name,
                address: this.client.address,
                documentNumber: this.client.document.number,
                countryIsoCode: this.client.country.isoCode
            }
        }
    }

    save() {
        this.dataTransform();
        this.myBookingService.createInvoice(this.$stateParams.bookingReference, this.dataTransformed).then(
            response => {
                this.cacheService.set('createInvoiceResponse', {status: 'success', message: 'invoice_correctly_created'});
                this.$state.go('bookings.booking.invoice', {}, { reload: true });
            },
            error => {
                this.cacheService.set('createInvoiceResponse', {status: 'error', message: 'something_went_wrong'});
            });
        this.$state.go('bookings.booking.invoice', {}, { reload: true });
    }
}

export default RequestInvoiceController;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/invoice/requestInvoice/requestInvoice.controller.js